import { TranslationFunctionType } from '@/common/types';
import { isEmpty } from 'lodash';
import { array, boolean, lazy, mixed, object, string } from 'yup';

export const azureAdSchema = (
  isSecretSet: boolean,
  t: TranslationFunctionType,
) =>
  object({
    clientId: string()
      .uuid(t('error.validValue'))
      .required(t('error.requiredField')),
    clientSecret: isSecretSet
      ? string().nullable()
      : string().required(t('error.requiredField')),
    tenantId: string()
      .uuid(t('error.validValue'))
      .required(t('error.requiredField')),
    active: boolean().default(false),
    mapping: lazy((value, context) => {
      const hasMapping =
        context.parent.active &&
        value !== null &&
        !(Array.isArray(value.mapping) && value.mapping.length === 0) &&
        !isEmpty(value.mapping);

      if (hasMapping) {
        const validationObject = {
          groupId: string()
            .uuid(t('error.enterObjectId'))
            .required(t('error.enterObjectId')),
          account: object().nullable(),
          branches: array(),
          // .when('account', ([account], schema) =>
          //   account ? schema : schema.min(1, t('error.selectBranch'))),
          groups: array(),
          language: string().required(t('error.requiredLanguage')),
        };
        const newEntries = Object.keys(value).reduce(
          (acc, val) => ({
            ...acc,
            [val]: object(validationObject),
          }),
          {},
        );

        return object().shape(newEntries);
      }
      return mixed();
    }),
  });
